import axios, { AxiosResponse } from 'axios'
import math from './math'
import text from './text'
import { cloneDeep } from 'lodash'

export type MyScriptStroke = {
  x: number[]
  y: number[]
}

export default class MyScript {
  lang: string | null
  strokes: MyScriptStroke[]
  width: number | null
  height: number | null
  content: math | text
  url: string
  applicationKey: string
  response: AxiosResponse | null
  latex: string
  html: string
  mathml2latex: any

  constructor(opt: { lang?: string; strokes?: MyScriptStroke[]; width?: number; height?: number } = {}) {
    this.lang = opt.lang ? opt.lang : null
    this.strokes = opt.strokes ? opt.strokes : []
    this.width = opt.width ? opt.width : null
    this.height = opt.height ? opt.height : null
    this.content = this.defineContent()
    this.url = 'https://sdk.combine-ink.jp/api/v4.0/iink/batch'
    this.applicationKey = '4250772a-ae88-4f36-83dd-c79f88f474f6'
    this.response = null
    this.latex = ''
    this.html = ''
    this.mathml2latex = require('mathml2latex')
  }

  get headers() {
    return {
      applicationKey: this.applicationKey,
      Accept: this.content.accept,
    }
  }

  get conversionState() {
    return 'DIGITAL_EDIT'
  }

  get body() {
    return {
      configuration: this.content.configuration,
      contentType: this.content.contentType,
      conversionState: this.conversionState,
      strokeGroups: [
        {
          penStyle: null,
          strokes: this.strokes,
        },
      ],
      width: this.width,
      height: this.height,
      xDPI: 96,
      yDPI: 96,
    }
  }

  set setSize(size: { width: number; height: number }) {
    this.width = size.width
    this.height = size.height
  }

  set setStrokes(strokes: MyScriptStroke[]) {
    this.strokes = strokes
  }

  defineContent(): math | text {
    if (this.lang === 'MATHML') return new math()
    return new text({ lang: this.lang })
  }

  async recognize() {
    this.response = await axios.post(this.url, this.body, { headers: this.headers })
    if (!this.response) return
    let result = this.response.data.toString()
    // 1.0などが1として処理されてしまうので別途処理
    if (this.lang === 'MATHML' && typeof this.response.data === 'number') {
      const cloneBody = cloneDeep(this.body)
      cloneBody.configuration.math.mimeTypes = ['application/mathml+xml']
      const cloneHeader = cloneDeep(this.headers)
      cloneHeader.Accept = 'application/json, application/mathml+xml'
      const mathmlResponse = await axios.post(this.url, cloneBody, { headers: cloneHeader })
      result = this.mathml2latex.default.convert(mathmlResponse.data)
    }
    this.latex = await this.convertResult(result)
    this.html = await this.convertHTML()
  }

  async convertResult(latex: string): Promise<string> {
    // 9yと書くとqyと変換されるため置換する
    if (latex.indexOf('qy') === 0) latex = latex.replace('q', '9')
    return latex
  }

  convertHTML(): string {
    return this.content.convertHTML(this.latex)
  }
}
